import PropTypes from 'prop-types';

import { Abstrap } from '../..';

const propTypes = { ...Abstrap.propTypes, active: PropTypes.bool };

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    active: false,
};

class TabItem extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            active,
        } = this.props;
        return [
            'c-tab__item',
            active ? 'is-active' : '',
            className,
        ];
    }

}

TabItem.propTypes = propTypes;

TabItem.defaultProps = defaultProps;

export default TabItem;
